export type AspectRatioType = '16-9' | '9-16' | '4-3' | '3-4' | '3-2' | '1-1' | 'none';

export const aspectRatioMapping: Record<AspectRatioType, number> = {
  '16-9': 16 / 9,
  '9-16': 9 / 16,
  '4-3': 4 / 3,
  '3-4': 3 / 4,
  '3-2': 3 / 2,
  '1-1': 1 / 1,
  none: 1
};
